import { render } from "./TokenList.vue?vue&type=template&id=40b7921d"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ionutcapraru/work/github/converter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__